var exports = {
  "kL": "x127c5a35--c1d644--container",
  "wx": "x127c5a35--c1d644--header",
  "Sl": "x127c5a35--c1d644--image",
  "Qs": "x127c5a35--c1d644--content",
};

module.exports = exports;
